const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const initialUser = {
  phone: '',
  email: '',
  password: '',
  passwordConfirm: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  checkedPers: false,
  checkedRules: false,
  subscribe: false,
  sex: 'male',
  office_id: null,
  post_id: null,
  dealer_name: '',
};

export default {
  props: ['type'],
  data() {
    return {
      user: { ...initialUser },
      tmpPhone: '',
      pageRules: null,
      pagePers: null,
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: null,
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      offices: [],
      searchOffice: '',
      posts: [],
      searchPost: '',
      email_redirect: false,
      region: 'RU',
      regionalPhone: '',
    };
  },
  computed: {
    isManager() { return this.$props.type === 'manager'; },
    isDealer() { return this.$props.type === 'dealer'; },
    requireRules() { return this.$store.state.settings.register_rules === true; },
    requirePers() { return this.$store.state.settings.register_pers === true; },
    registerType() {
      let type;
      if (this.isManager || this.email_redirect) {
        type = 'email_noprofile_or_unregistered';
      }
      if (this.isDealer && !this.email_redirect) {
        type = 'sms_noprofile_or_unregistered';
      }
      return type;
    },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() { return this.$store.state.loading; },
    settings() { return this.$store.state.settings; },
  },
  methods: {
    SetPhone(e) {
      this.user.phone = e.target.value;
    },
    OpenRules() {
      if (this.user.office_id) {
        this.dialogRules = true;
      }
    },
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      const payload = {};
      if (this.isManager) {
        payload.email = app.user.email;
      }
      if (this.isDealer) {
        payload.phone = app.user.phone;
      }
      app.$store.getters.ax.post('profiles/api/v3/register/info', { ...payload })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          // app.pageRules = response.data.pageRules;
          app.$store.getters.ax.post('/pages/api/pages', {
            url: app.isDealer
              ? `manager_dealer_${app.region || 'ru'}`
              : `manager_kmp_${app.region || 'ru'}`,
          });
          // .then((res) => {
          // app.pageRules = res.data.page;
          // });
          const { profile } = response.data;
          if (profile) {
            profile.first_name && app.$set(app.user, 'first_name', profile.first_name);
            profile.last_name && app.$set(app.user, 'last_name', profile.last_name);
            profile.middle_name && app.$set(app.user, 'middle_name', profile.middle_name);
            profile.email && app.$set(app.user, 'email', profile.email);
            profile.phone_mobile && app.$set(app.user, 'phone', profile.phone_mobile);
            profile.sex && app.$set(app.user, 'sex', profile.sex);
            app.$set(app.user, 'profile_id', profile.profile_id);
            profile.dealer_name && app.$set(app.user, 'dealer_name', profile.dealer_name);
            if (profile.office && profile.office.id) {
              app.$set(app.user, 'office_id', profile.office.id);
              app.searchOffice = profile.office.name;
              this.OfficeChange(this.user.office_id);
            }
            if (profile.post && profile.post.id) {
              app.$set(app.user, 'post_id', profile.post.id);
              app.searchPost = profile.post.name;
            }
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = { ...initialUser };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.Focus(this.isDealer ? 'phone' : 'email');
    },
    /** Отправка проверочного СМС кода */
    SendSMSCode() {
      const app = this;
      const url = 'profiles/api/v3/token/get-sms';

      app.$store.getters.axl.post(url, { type: app.registerType, phone: app.user.phone })
        .then(({ data }) => {
          app.email_redirect = data.email_redirect;
          app.region = data.region;
          app.regionalPhone = data.email_redirect ? app.user.phone : '';
          if (!data.email_redirect) {
            app.sentCode = true;
            app.Focus('regCode');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('phone');
        });
    },
    /** Отправка проверочного email кода */
    SendEmailCode() {
      const app = this;
      const url = 'profiles/api/v3/token/get-email';

      app.$store.getters.axl.post(url, { type: app.registerType, email: app.user.email })
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('email');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckSMSCode() {
      const app = this;
      const url = 'profiles/api/v3/token/check-sms';
      const payload = { type: app.registerType, code: app.code, phone: app.user.phone };

      app.$store.getters.axl.post(url, payload)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('regLastName');
          app.LoadRegInfo();
          app.email_redirect && app.$set(app.user, 'phone', app.regionalPhone);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Проверка кода полученного в email */
    CheckEmailCode() {
      const app = this;
      const url = 'profiles/api/v3/token/check-email';
      const payload = { type: app.registerType, code: app.code, email: app.user.email };

      app.$store.getters.axl.post(url, payload)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('regLastName');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = app.user;
      // eslint-disable-next-line no-nested-ternary
      const url = app.isDealer && !app.email_redirect
        ? 'profiles/api/v3/register/by-phone'
        : this.email_redirect ? 'profiles/api/v3/register/aliens-by-email' : 'profiles/api/v3/register/by-email';
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post(url, formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    OfficeChange(id) {
      const app = this;
      if (id) {
        app.$store.getters.axl.post('/profiles/api/v3/rules/get-by-office', {
          office_id: id,
          role: app.$props.type === 'dealer' ? 'manager_dealer' : 'manager_kmp',
        })
          .then((res) => {
            app.user.checkedRules = false;
            app.pageRules = res.data.pageRules;
            console.log(res.data.pageRules);
          });
      } else {
        app.pageRules = null;
        app.user.checkedRules = false;
      }
    },
  },
  watch: {
    searchOffice(name) {
      name && this.$store.getters.ax.post('profiles/api/dictionaries/offices', { name })
        .then((result) => {
          this.offices = result.data.offices;
        });
    },
    searchPost(name) {
      name && this.$store.getters.ax.post('profiles/api/dictionaries/posts', { name })
        .then((result) => {
          this.posts = result.data.posts;
        });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus(this.isDealer ? 'phone' : 'email');
  },
};
